import { useEffect, useState } from "react";
import { Gift, Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export const ReferralCard = () => {
  const [info, setInfo] = useState(null);

  useEffect(() => { api.get("/referral").then((r) => setInfo(r.data)).catch(() => {}); }, []);

  if (!info) return null;
  const shareText = `Ik plan mijn elektrische roadtrips met VoltRoute — route, laadstops, hotels en budget in één app. Meld je aan via mijn link en we krijgen allebei 1 maand Pro gratis! ${info.link}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(info.link);
      toast.success("Uitnodigingslink gekopieerd!");
    } catch {
      toast.info(info.link, { duration: 8000 });
    }
  };

  return (
    <div data-testid="referral-card" className="bg-card rounded-2xl p-4 sm:p-5 mb-8 flex flex-col sm:flex-row sm:items-center gap-3">
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <span className="w-10 h-10 rounded-full bg-[#B5838D]/15 flex items-center justify-center shrink-0">
          <Gift className="w-5 h-5 text-[#B5838D]" />
        </span>
        <div className="min-w-0">
          <p className="text-sm font-semibold">Nodig een vriend uit — jullie krijgen allebei 1 maand Pro gratis</p>
          <p className="text-xs text-muted-foreground truncate" data-testid="referral-link">
            {info.link}{info.count > 0 ? ` · al ${info.count} aangemeld via jouw link` : ""}
          </p>
        </div>
      </div>
      <div className="flex gap-2 shrink-0">
        <button data-testid="referral-copy-button" onClick={copy}
          className="flex items-center gap-1.5 rounded-full bg-secondary hover:bg-secondary/70 px-4 py-2.5 text-xs font-bold active:scale-95 transition-[transform,background-color] duration-200">
          <Copy className="w-3.5 h-3.5" /> Kopieer link
        </button>
        <a data-testid="referral-whatsapp-button" href={`https://wa.me/?text=${encodeURIComponent(shareText)}`} target="_blank" rel="noreferrer"
          className="flex items-center gap-1.5 rounded-full bg-[#25D366] text-white px-4 py-2.5 text-xs font-bold hover:opacity-90 active:scale-95 transition-[transform,opacity] duration-200">
          <MessageCircle className="w-3.5 h-3.5" /> WhatsApp
        </a>
      </div>
    </div>
  );
};
